import React from 'react';
import { NavLink } from 'react-router-dom';
import Footer from '../../components/Footer';
import { useWindowWidth } from '../../hooks/useWindowWidth';

const INK  = '#0A1F4A';
const INK2 = '#3D4F78';
const INK3 = '#7883A2';
const BG   = '#ECEEF3';
const SURF = '#FFFFFF';
const RULE = '#D6DAE4';
const ACC  = '#FF7A3D';

const LINKS = [
  { to: '/privacy', label: 'Privacy policy' },
  { to: '/terms',   label: 'Terms of service' },
  { to: '/gdpr',    label: 'GDPR & data' },
  { to: '/cookies', label: 'Cookie policy' },
];

export default function LegalPage({ title, kicker = 'Legal', lastUpdated, children }) {
  const isMobile = useWindowWidth() < 768;
  const ctr = { maxWidth: 800, margin: '0 auto', padding: '0 24px' };

  return (
    <>
      <section style={{ padding: isMobile ? '72px 0 56px' : '96px 0 72px', background: INK }}>
        <div style={ctr}>
          <span style={{
            display: 'block', marginBottom: 12,
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: 11, fontWeight: 600, letterSpacing: '0.14em',
            textTransform: 'uppercase', color: ACC,
          }}>
            {kicker}
          </span>
          <h1 style={{
            fontSize: isMobile ? 36 : 52, fontWeight: 700,
            letterSpacing: '-0.03em', color: BG, margin: '0 0 16px',
          }}>
            {title}
          </h1>
          <p style={{
            color: INK3, fontFamily: '"JetBrains Mono", monospace',
            fontSize: 13, margin: 0,
          }}>
            Last updated: {lastUpdated}
          </p>
        </div>
      </section>

      <div style={{ background: SURF, borderBottom: `1px solid ${RULE}` }}>
        <div style={{ ...ctr, display: 'flex', gap: 0, overflowX: 'auto' }}>
          {LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              style={({ isActive }) => ({
                display: 'block',
                padding: '11px 16px',
                fontSize: 13, fontWeight: 500,
                color: isActive ? INK : INK2,
                textDecoration: 'none', whiteSpace: 'nowrap',
                borderBottom: `2px solid ${isActive ? ACC : 'transparent'}`,
              })}
            >
              {label}
            </NavLink>
          ))}
        </div>
      </div>

      <div style={{ background: BG, minHeight: '60vh', padding: isMobile ? '40px 0 80px' : '56px 0 120px' }}>
        <div style={ctr}>
          <div style={{
            background: SURF, border: `1px solid ${RULE}`,
            borderRadius: 12, padding: isMobile ? '32px 24px' : '56px 64px',
          }}>
            {children}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
